<!--@format-->
<template>
    <div class="integration-enable-disable-popup">
        <app-button
            v-if="!element.enabled"
            class="outside-button secondary-btn"
            :on-click="closePopup"
        >
            <span class="fa fa-arrow-left" />
            Return to Integrations
        </app-button>
        <section class="user-information-container">
            <app-profile-image :src="element.profileImageUrl | profileImagePlaceholder" />
            <div class="user-information">
                <span class="user-name">{{ element.userName }}</span>
                <p class="user-email">({{ element.email }})</p>
            </div>
        </section>
        <section class="date-information">
            Has disabled your integration on
            <div v-if="element.disabledDate" class="full-date-time-cell">
                <span class="date-element"
                    >{{ element.disabledDate | momentWeekDay | UpperCaseString }}
                </span>
                <span>{{ element.disabledDate | momentDateMMMDYYYY | UpperCaseString }} </span>
                <span class="date-element-time">{{ element.disabledDate | momentTime }}</span>
            </div>
        </section>
        <section class="disabled-enabled-container">
            Would you like to switch your integration back on
            <app-switch :value="element.enabled" @input="toggleDisabled()" />
        </section>
    </div>
</template>

<script>
const AppProfileImage = () => import('@/components/common/app-profile-image');
const AppSwitch = () => import('@/components/common/app-switch');
const AppButton = () => import('@/components/common/app-button');

import EventBus from '@/scripts/event-bus';

export default {
    name: 'integration-enable-disable-popup',

    components: {
        'app-profile-image': AppProfileImage,
        'app-switch': AppSwitch,
        'app-button': AppButton,
    },

    props: {
        element: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            setTimeFunction: null,
        };
    },

    computed: {
        elementComputed() {
            return this.element;
        },
    },

    created() {
        EventBus.$on('active-integration', this.setOnIntegration);
    },

    destroyed() {
        EventBus.$off('active-integration', this.setOnIntegration);
    },

    methods: {
        toggleDisabled() {
            EventBus.$emit('toggle', this.element.enabled);
            if (this.element.enabled) {
                this.closeWithTimeout();
            }
        },

        closeWithTimeout() {
            this.setTimeFunction = setTimeout(() => {
                this.closePopup();
            }, 2500);
        },

        setOnIntegration() {
            this.elementComputed.enabled = !this.elementComputed.enabled;
            clearTimeout(this.setTimeFunction);
            if (this.element.enabled) {
                this.closeWithTimeout();
            }
        },

        closePopup() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.integration-enable-disable-popup {
    text-align: center;
    --background-color: transparent;
}

.integration-enable-disable-popup .user-information-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 120px;
    gap: 15px;
}

.integration-enable-disable-popup .user-information {
    text-align: left;
    letter-spacing: 0px;
    color: #382153;
    word-break: break-word;
}

.integration-enable-disable-popup .app-profile-image .background-image {
    height: 84px;
    width: 84px;
}

.integration-enable-disable-popup .user-information-container .user-information .user-name {
    font: normal normal bold 20px/26px Roboto;
}

.integration-enable-disable-popup .user-information-container .user-information .user-email {
    font: normal normal normal 14px/19px Roboto;
}

.integration-enable-disable-popup .disabled-enabled-container {
    display: flex;
    gap: 10px;
    align-items: center;
    border: 2px solid #dcdcdc;
    border-radius: 48px;
    padding: 33px 64px;
    margin-bottom: 20px;
}

.integration-enable-disable-popup .date-information {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
}

.integration-enable-disable-popup .date-element {
    border-right: 2px solid #dcdbe0;
    margin-right: 10px;
    padding-right: 10px;
}

.integration-enable-disable-popup .date-element-time {
    border-left: 2px solid #dcdbe0;
    margin-left: 10px;
    padding-left: 10px;
}

.integration-enable-disable-popup .app-switch {
    width: initial;
    background: #e9e9ef 0% 0% no-repeat padding-box;
    border: 1px solid #d3d3d3;
    border-radius: 13px;
}

.integration-enable-disable-popup .app-switch .app-switch-container {
    height: 25px;
}

.integration-enable-disable-popup .app-switch .app-switch-container .app-switch-value-text {
    top: -5px;
    left: 21px;
    color: #877d88;
}

.integration-enable-disable-popup .outside-button {
    position: fixed;
    top: 30px;
    left: 100px;
    display: flex;
    gap: 10px;
}

.integration-enable-disable-popup .outside-button {
    background: transparent;
    border: 1px solid #ffffff;
    border-radius: 24px;
}

.integration-enable-disable-popup .outside-button:hover {
    background: #ffffff 0% 0% no-repeat padding-box;
    color: #382153;
}
</style>
